import { render, staticRenderFns } from "./observa4Pellet.vue?vue&type=template&id=6f73d344&scoped=true"
import script from "./observa4Pellet.vue?vue&type=script&lang=js"
export * from "./observa4Pellet.vue?vue&type=script&lang=js"
import style0 from "./observa4Pellet.vue?vue&type=style&index=0&id=6f73d344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f73d344",
  null
  
)

export default component.exports